import { render } from "./KatButton.vue?vue&type=template&id=0398f1a2&scoped=true"
import script from "./KatButton.vue?vue&type=script&lang=js"
export * from "./KatButton.vue?vue&type=script&lang=js"

import "./KatButton.vue?vue&type=style&index=0&id=0398f1a2&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0398f1a2"]])

export default __exports__